import config from '../../assets/js/conf/config'
import request from '../../assets/js/utils/request'

/** 微店售后配置详情 */
export function getAftersaleConfigDetail(data) {
	return request.get(config.baseApiB + '/api/v1/wxshop/aftersale-config/detail', data || {})
}

/** 保存微店售后配置 */
export function postAftersaleConfigSave(data) {
	return request.post(config.baseApiB + '/api/v1/wxshop/aftersale-config/save', data || {})
}
